import React from 'react';
import { Link } from 'react-router-dom';
import { FiTarget, FiHeart, FiTrendingUp, FiUsers } from 'react-icons/fi';
import { Helmet } from 'react-helmet-async';

const About = () => {
  const values = [
    { icon: <FiTarget className="w-8 h-8" />, title: 'Our Mission', desc: 'To revolutionize dairy farming by connecting investors with sustainable, profitable farming opportunities.' },
    { icon: <FiHeart className="w-8 h-8" />, title: 'Our Vision', desc: 'To become India\'s most trusted agri-investment platform, creating wealth for investors and prosperity for farmers.' },
    { icon: <FiTrendingUp className="w-8 h-8" />, title: 'Our Promise', desc: 'Guaranteed returns, complete transparency, and professional farm management.' },
    { icon: <FiUsers className="w-8 h-8" />, title: 'Our Community', desc: '12,500+ happy investors and 15+ partner farms across India.' }
  ];

  return (
    <>
      <Helmet>
        <title>About Us - MilkDairy Investor Portal</title>
      </Helmet>

      <div className="bg-white">
        {/* Hero */}
        <div className="bg-gradient-to-r from-green-700 to-green-900 text-white py-20">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">About MilkDairy</h1>
            <p className="text-xl max-w-2xl mx-auto opacity-90">India's Most Trusted Dairy Investment Platform</p>
          </div>
        </div>

        {/* Story */}
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Our Story</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              Founded in 2015, MilkDairy started with a simple mission - to bridge the gap between urban investors and India's traditional dairy farming sector. We realized that while dairy farming offers stable, predictable returns, most retail investors don't have access to this asset class.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              Today, we've grown into India's leading dairy investment platform, managing over ₹250+ crores in assets and serving 12,500+ satisfied investors. Our technology-driven approach ensures complete transparency, from investment to monthly returns.
            </p>
          </div>
        </div>

        {/* Values */}
        <div className="bg-gray-50 py-16">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Our Core Values</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {values.map((value, idx) => (
                <div key={idx} className="bg-white p-6 rounded-xl shadow-md text-center hover:shadow-lg transition">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 text-green-600">
                    {value.icon}
                  </div>
                  <h3 className="text-xl font-semibold mb-2">{value.title}</h3>
                  <p className="text-gray-600">{value.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="container mx-auto px-4 py-16 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Ready to Start Investing?</h2>
          <p className="text-gray-600 mb-8">Join thousands of investors earning guaranteed returns with MilkDairy</p>
          <Link to="/investor/plans" className="bg-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700 transition inline-block">
            Explore Investment Plans
          </Link>
        </div>
      </div>
    </>
  );
};

export default About;